/* eslint-disable jsx-a11y/anchor-has-content */
import React, { useCallback } from "react"
import { Link } from "gatsby"
import { postAppMsg, platformCheck } from "@utils/request"

const Clickable = ({
  to,
  disabled,
  href,
  appNavTo,
  newWindow = true,
  ...restProps
}) => {
  const handleClick = useCallback(
    (e) => {
      platformCheck(
        () => {
          postAppMsg("navigate", {
            link: appNavTo,
          })
          e.preventDefault()
        },
        () => {
          // window.location.href = appNavTo
        },
        {
          onlyInApp: /^app:\/\//.test(appNavTo),
        }
      )
      if (props.onClick) {
        props.onClick()
      }
    },
    [appNavTo]
  )

  const props = {
    ...restProps,
    ...(newWindow
      ? {
          target: "_blank",
        }
      : null),
  }

  if (disabled) {
    return <div {...props} />
  }

  if (to) {
    return <Link to={to} {...props} />
  }

  if (href) {
    return <a href={href} {...props} />
  }

  if (appNavTo) {
    return <a href={appNavTo} {...props} onClick={handleClick} />
  }

  return <a role="button" tabIndex={0} {...props} />
}

export default Clickable
